/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["footer[_ngcontent-%COMP%]{margin:0 auto;padding:16px 0;width:calc(100vw - 16px * 2);max-width:990px}.facebook[_ngcontent-%COMP%]{opacity:.5;color:#3a3a3a}.facebook[_ngcontent-%COMP%]:hover{opacity:1;color:#00f}nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#939494;text-align:center;text-decoration:none;text-transform:uppercase;padding:8px 0}section[_ngcontent-%COMP%]{background:#fafafa;border-top:1px solid #eaeaea}"];
export { styles as styles };
